import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../provider/ServiceProvider";
import "./MarketOutlook.css";
import animation from "../../images/jm-animation.gif";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import URLstateContext from "../../provider/CommonContext";


function MarketOutlookComponent() {
  const [data, setData] = useState([]);
  const [loadingshow, setloadingshow] = useState(true);
  const [show, setShow] = useState(false);
  const [FetchDatavdo, setFetchDatavdo] = useState([]);
  const { BaseURL } = useContext(URLstateContext);

  useEffect(() => {
    // Fetch Market Outlook data when component mounts
    fetchMarketOutlookData();
  }, []);

  const clickyoutube = (event) => {
    setShow(true);
    fetchVideoLink(event);
  };

  const fetchMarketOutlookData = () => {
    // Fetch Market Outlook data from the API
    GetPostMethodData(BaseURL + "GetCommunicationHub", {
      IICategoryID: 2, // Assuming 2 is the ID for Market Outlook
      IISubCategoryID: 0,
    }).then((responseData) => {
      if (responseData.data != null && responseData.data.length > 0) {
        setData(DecryptAESdata(responseData.data));
        setloadingshow(false);
      } else {
        setData([]);
        setloadingshow(false);
      }
    });
  };

  const fetchVideoLink = (event) => {
    GetPostMethodData(BaseURL + "GetVideoLink", {
      IVsrno: event,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setFetchDatavdo(DecryptAESdata(data.data));
      }
    });
  };

  const handleClosePopup = () => {
    setShow(false);
  };

  return (
    <>
      <section className="market-outlook-section" style={{padding : 0}}>
        <Container>
          <Row>
            <Col sm={12} style={{padding : 0}}>
              <div className="market-outlook-container">
                {data && data.length === 0 && loadingshow === false ? (
                  <h1 className="errormsgComNew" role="alert">No Data Available !!!</h1>
                ) : (
                  data &&
                  data.map(({ Title, ThumbnailImage, CommunicationID }) => (
                    <div
                      className="market-outlook-item zoom"
                      key={CommunicationID}
                    >
                      <h2>{Title?.replace(/\|/g, " - ")}</h2>
                      {/* <span onClick={() => clickyoutube(CommunicationID)}>
                        <img
                          src={ThumbnailImage}
                          className="img-fluid"
                          alt="Thumbnail"
                        />
                      </span> */}
                      <button
                          type="button"
                          className="thumbnail-btn"
                          onClick={() => clickyoutube(CommunicationID)}
                          aria-label={`Play video: ${Title}`}
                        >
                          <img
                            src={ThumbnailImage}
                            className="img-fluid"
                            alt={`${Title}`}
                          />
                        </button>
                    </div>
                  ))
                )}
                {loadingshow && (
                  <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {FetchDatavdo &&
        FetchDatavdo.map(({ Title, LinkLocation }, index) => (
          <Modal show={show} className="modal modal-teams" key={index}  enforceFocus restoreFocus autoFocus>
            <Modal.Body id="modal_info">
              <div className="btnDiv">
                {/* <div className="" onClick={handleClosePopup}>
                  <AiFillCloseCircle className="btncl" />
                </div> */}
                <button
                    type="button"
                    className="btn-close-icon"
                    onClick={handleClosePopup}
                    aria-label="Close video dialog"
                  >
                    <AiFillCloseCircle className="btncl" aria-hidden="true" focusable="false" />
                  </button>
              </div>
              <div className="youtubepopup">
                <p>{Title}</p>
                <div>
                  <iframe
                    className="iframe-vdo"
                    src={LinkLocation}
                    title={Title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        ))}
    </>
  );
}

export default MarketOutlookComponent;
